import { icons } from '../components/Icons';
import { trpc } from '../lib/trpc';
import { notifications } from '@mantine/notifications';
import { useState } from 'react';

export const useDownloadFile = () => {
  const [downloadingKey, setDownloadingKey] = useState<null | string>(null);
  const { mutateAsync: createPresignedDownload } =
    trpc.files.createPresignedDownload.useMutation();

  const downloadFile = async (contextRecordId: string) => {
    setDownloadingKey(contextRecordId);
    try {
      const result = await createPresignedDownload({ contextRecordId });
      if (result.ok) {
        document.location.href = result.presignedUrl;
      } else {
        notifications.show({
          message: (
            <>
              <icons.Failure />
              Failed to create presigned download URL
            </>
          ),
        });
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    } finally {
      setDownloadingKey(null);
    }
  };

  return { downloadFile, downloadingKey };
};
